export default {
  noExportSettings: 'Keiner der Blöcke dieses Berichts braucht Einstellungen für den Export.',
};
